module.exports = __webpack_public_path__ + "static/img/default_nodata@2x.fb268012.png";